export default "__VITE_ASSET__CgCUTMsk__"